export default "__VITE_ASSET__d9891cc5__"